// import { Link } from "react-router-dom";

// export default function DevLog() {
//   return (
    
//     <div className="dev-log-page">
//       <section className="text-area">
//         <h1>Dev Log</h1>
//           <div className="coldflare-links">
//             <Link className="page-button" to='/coldflarestudios'>
//               <p>Back To ColdFlare Studios Page</p>
//             </Link>
//           </div>
//       </section> 

//     </div>
    
//   );
// }

// src/pages/DevLog.jsx

import { Link } from "react-router-dom";
import { devLogs } from "../data/devLogs";

function DevLog() {
  return (
    <main className="dev-log-page">
      <section className="text-area">
        <h1>Dev Log</h1>
        <p>
          Updates from ColdFlare Studios, including game releases, experiments,
          prototypes, and behind-the-scenes progress.
        </p>

        <div className="dev-log-list">
          {devLogs.map((post) => (
            <article className="dev-log-card" key={post.id}>
              <p className="dev-log-date">{post.date}</p>
              <h2>{post.title}</h2>
              <p>{post.excerpt}</p>

              <Link className="page-button" to={`/dev-log/${post.id}`}>
                Read More
              </Link>
            </article>
          ))}
        </div>
        <div className="coldflare-links">
             <Link className="page-button" to='/coldflarestudios'>
               <p>Back To ColdFlare Studios Page</p>
             </Link>
        </div>
      </section>
      
    </main>
  );
}

export default DevLog;
